// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"509006ce","293":"3a13569e","508":"29cfa7d7","746":"141fc7b8","854":"1ad11401","932":"0508f209"}[chunkId] + ".chunk.js";
};